export const IOTSimListLookupToken = {
  IIOTSimListLookupRepository: Symbol("IIOTSimListLookupRepo"),
  IOTSimListLookupUseCase: Symbol("IOTSimListLookupUseCase"),
  IOTSimListLookupViewModel: Symbol("IOTSimListLookupViewModel"),
};
